import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, TemplateRef, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { I18nService } from '../../../../@core/services/i18n/i18n.service';
import { SystemService } from '../../../../@core/services/system.service';
import { PhxSelect } from '../../../../shared/components/phx-select/phx-select.component';
import { GenericEnumDropDownComponent } from '../../../../shared/controls/generic-enum-drop-down/generic-enum-drop-down.component';

@Component({
    selector: 'app-backup-type-drop-down',
    templateUrl: './backup-type-drop-down.component.html',
    styleUrls: ['./backup-type-drop-down.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [SystemService],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TooltipModule,
        TranslateModule,
        FormlyModule,
        PhxSelect,
    ],
})
export class BackupTypeDropDownComponent extends GenericEnumDropDownComponent implements AfterViewInit {
    private i18n = inject(I18nService);

    @ViewChild('itemTemplate', { static: false }) itemTemplateRef: TemplateRef<any>;
    @ViewChild('selectedItemTemplate', { static: false }) selectedItemTemplateRef: TemplateRef<any>;

    constructor() {
        super(inject(SystemService));
    }

    ngAfterViewInit(): void {
        // Set templates to Input properties after view init
        if (this.itemTemplateRef) {
            this.itemTemplate = this.itemTemplateRef;
        }
        if (this.selectedItemTemplateRef) {
            this.selectItemTemplate = this.selectedItemTemplateRef;
        }
    }

    getTooltip(key: string): string {
        if (key === 'DATABASE_ONLY') {
            return this.i18n.translate('admin.backups.backup-type-database-only-tooltip');
        } else if (key === 'FULL') {
            return this.i18n.translate('admin.backups.backup-type-full-tooltip');
        }
        return '';
    }
}
